import 'leaflet-draw';
import drawLocal from './ToolBarLang';

(window as any).L.drawLocal = drawLocal;